// extracted by mini-css-extract-plugin
module.exports = {"findProductButton":"_3Hkmb","text":"_4jYOl","firstText":"_3WcHh","findIcon":"_3t-0x"};